// extracted by mini-css-extract-plugin
export default {"search":"styles_search__PREtV","icon":"styles_icon__v-Lxe","input":"styles_input__t6g0Y","close":"styles_close__e3pvo"};